import { useEffect, useState } from 'react';
import { Modal } from '../../../theme/Component/Modal';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _BudgetID } from '../../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';
import { Product } from '../../../Inventories-Warehouses/Product/Product';
import { _Product } from '../../../../core/services/dataBean/EntityCatalogVdos';


interface Props {
    value?: any;
    renderValue?: string;
    onChange: any;
    label?: string;
    disabled?: boolean
    filterType?: number;
}
export const SelectProductEditor = ({ value, onChange, label, filterType, renderValue, disabled }: Props) => {

    const { instance } = useDataBean(_Product)

    const [modal, setModal] = useState<any>({ name: 'Catálogo de Productos de Inventario', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [valor, setValor] = useState('');
    const [obj, setObj] = useState<any>({});

    useEffect(() => {
        if (renderValue) {
            setValor(renderValue)
        }
    }, [renderValue])



    const getProduct = () => {

    }

    const returnValue = () => {
        if (obj.IDProduct) {
            setValor(`${obj.IDProduct ?? ""} - ${obj.Description} - $${obj.SalesValue}`)
            setModal({ ...modal, "view": false });
            onChange(obj);
        } else {
            toast.error("Producto no valido")
        }
    }

    return (
        <>
            <label>{label ?? "Seleccione un Producto"}</label>
            <div
                className={`form-control text-wrap ${disabled ? 'bg-light text-muted' : 'cursor-pointer'}`}
                style={{ minHeight: '35px' }}
                onClick={() => {
                    if (!disabled) {
                        setModal({ ...modal, view: true });
                    }
                }}
            >
                {valor ? valor : <span>Seleccionar...</span>}
            </div>

            <Modal onSubmitLabel='Seleccionar' modal={modal} updateModal={setModal} eventModal={returnValue}>
                <Product filterType={filterType} onChange={(e) => { setObj(e) }} isModal />
            </Modal>

        </>
    )
}